var _rect, _rect2, _g, _path, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanInfiniteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 1.5,
    fill: "url(#paint0_linear_9733_237523)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9733_237523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 50,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 2,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9733_237523)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9733_237523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1765 40.826C26.9729 43.4678 25.855 45.9561 24.0151 47.8627C22.7747 49.3662 21.2172 50.5769 19.4542 51.408C17.6911 52.2391 15.7661 52.6701 13.817 52.6701C11.8678 52.6701 9.94283 52.2391 8.17977 51.408C6.41672 50.5769 4.66028 49.6603 3.24462 48.2446C1.82896 46.8292 0.904681 45.0649 0.0735692 43.3018C-0.757543 41.5388 -1.18853 39.6137 -1.18853 37.6646C-1.18853 35.7155 -0.757543 33.7905 0.0735694 32.0274C0.904681 30.2644 2.11535 28.7069 3.61889 27.4665C12.9671 18.1183 38.4623 33.4154 47.8106 24.0672C49.3141 22.8268 50.5248 21.2693 51.3559 19.5063C52.187 17.7432 52.618 15.8182 52.618 13.8691C52.618 11.9199 52.187 9.99493 51.3559 8.23188C50.5248 6.46882 49.7101 4.92939 48.2786 3.49785C46.509 1.72828 45.0128 0.956787 43.2497 0.125675C41.4866 -0.705437 39.5616 -1.13643 37.6125 -1.13643C35.6634 -1.13643 33.7384 -0.705437 31.9753 0.125675C30.2122 0.956787 28.6548 2.16746 27.4144 3.671C25.6719 5.55737 24.6178 7.97708 24.423 10.5377",
    stroke: "#B5BFE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1868 31.2206C25.0625 32.8933 24.8764 34.9021 24.1889 36.7321C23.0217 39.8416 19.964 41.593 16.5268 41.1926C13.5765 40.8495 10.8554 38.2619 10.4615 35.281C10.2753 33.8442 10.4104 32.5086 11.106 31.0707C12.1859 28.7556 13.9703 27.4963 16.3406 27.0174C18.5819 26.5671 20.5612 25.6881 22.2297 24.1512C22.3118 24.0877 22.3915 23.9985 22.4699 23.9223C24.2816 22.3926 25.4489 19.5042 26.2079 17.324C26.5159 16.459 26.5373 15.5297 26.924 14.6719C28.1127 12.0271 30.2037 10.6045 33.018 10.3972C35.7176 10.1971 37.8874 11.3551 39.4484 13.5782C39.8781 14.2001 40.1836 14.8779 40.3363 15.6441C40.6586 17.1885 40.7377 18.6536 40.1291 20.119C39.4703 21.8418 38.3455 23.1355 36.6841 23.9647C36.5839 24.0147 36.4881 24.0577 36.3764 24.0947C35.8138 24.3229 35.2668 24.5155 34.6796 24.637C30.7555 25.4305 27.8982 27.5893 26.1868 31.2206Z",
    fill: "#BDDBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1979,
    cy: 36.6771,
    r: 5.48958,
    stroke: "#BDDBFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2813,
    cy: 14.8022,
    r: 6.01042,
    stroke: "#BDDBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9733_237523",
    x1: 26,
    y1: 50.5,
    x2: 26,
    y2: -5.17853e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1062D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9733_237523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanInfiniteIcon);
export default __webpack_public_path__ + "static/media/PlanInfiniteIcon.382484b7c92a7765134a370b149cc008.svg";
export { ForwardRef as ReactComponent };